export const GET_COUNTRY_INDUSTRY_REPORTS_LIST = 'GET_COUNTRY_INDUSTRY_REPORTS_LIST';
export const GET_COUNTRY_INDUSTRY_REPORTS_LIST_SUCCESS = 'GET_COUNTRY_INDUSTRY_REPORTS_LIST_SUCCESS';
export const GET_COUNTRY_INDUSTRY_REPORTS_LIST_FAILURE = 'GET_COUNTRY_INDUSTRY_REPORTS_LIST_FAILURE';

export const getCountryIndustryReportsList = (payload) => ({
    type: GET_COUNTRY_INDUSTRY_REPORTS_LIST,
    payload,
});

export const getCountryIndustryReportsListSuccess = (data) => {
    return {
        type: GET_COUNTRY_INDUSTRY_REPORTS_LIST_SUCCESS,
        payload: data
    }
}

export const getCountryIndustryReportsListFailure = (data) => {
    return {
        type: GET_COUNTRY_INDUSTRY_REPORTS_LIST_FAILURE,
        payload: data
    }
}

export const EDIT_REPORT = "EDIT_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";

export const editReport = (payload) => ({
  type: EDIT_REPORT,
  payload,
});

export const deleteReport = (payload) => ({
  type: DELETE_REPORT,
  payload,
});

export const CREATE_REPORT = "CREATE_REPORT";

export const createReport = (payload) => ({
  type: CREATE_REPORT,
  payload,
});
